import { loginPluginFunc }   from '@tencent/ceiba-act-public-auto-detect-ast-login';
// import { loginPluginFunc }   from '../auto-detect-ast-login';

import login from './login';

const loginPlugin = {
  install(Vue) {
    Vue.prototype.$loginTgclubPlugin = {
      // eslint-disable-next-line max-len
      initLogin: params => (loginPluginFunc().initLogin ? loginPluginFunc().initLogin(params) : login.initLogin(params)),
      // eslint-disable-next-line max-len
      checkLogin: params => (loginPluginFunc().checkLogin ? loginPluginFunc().checkLogin(params) : login.checkLogin(params)),
      login: params => (loginPluginFunc().login ? loginPluginFunc().login(params) : login.login(params)),
      logout: params => (loginPluginFunc().logout  ? loginPluginFunc().logout(params)  : login.logout(params)),
    };
  },
};
export default loginPlugin;
